import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-style-two',
  templateUrl: './progress-style-two.component.html',
  styleUrls: ['./progress-style-two.component.scss']
})
export class ProgressStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
